import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { BottomNav } from '../components/BottomNav';
import { Trophy, Flame, Tag, MessageSquare, Megaphone } from 'lucide-react';

import ChallengesPage from './ChallengesPage';
import BonPlanPage from './BonPlanPage';
import CommunautePage from './CommunautePage';
import ChallengePage from './ChallengePage';
import CommunicationTab from './CommunicationTab';

const TABS = [
  { id: 'transfo', icon: Trophy, label: 'Challenge' },
  { id: 'defis', icon: Flame, label: 'Defis' },
  { id: 'plans', icon: Tag, label: 'Bons Plans' },
  { id: 'commu', icon: MessageSquare, label: 'Communaute' },
  { id: 'comm', icon: Megaphone, label: 'Comms', adminOnly: true },
];

export default function HubPage() {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(tabFromUrl && TABS.some(t => t.id === tabFromUrl) ? tabFromUrl : 'transfo');
  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (tabFromUrl && TABS.some(t => t.id === tabFromUrl) && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  const handleTabChange = (id) => {
    setActiveTab(id);
    setSearchParams({ tab: id });
  };

  return (
    <div className="min-h-screen bg-[#0F0F0F] pb-20">
      <div className="sticky top-0 z-40 bg-[#0F0F0F] border-b border-[#2A2A2E]">
        <div className="flex overflow-x-auto no-scrollbar" style={{ WebkitOverflowScrolling: 'touch' }}>
          {TABS.filter(t => !t.adminOnly || isAdmin).map(({ id, icon: Icon, label }) => (
            <button
              key={id}
              onClick={() => handleTabChange(id)}
              data-testid={`hub-tab-${id}`}
              className={`flex-1 flex items-center justify-center gap-1.5 min-h-[48px] px-3 text-xs font-semibold transition-colors border-b-2 whitespace-nowrap flex-shrink-0 ${
                activeTab === id
                  ? 'text-[#FF6B35] border-[#FF6B35]'
                  : 'text-zinc-500 border-transparent active:text-zinc-300'
              }`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === 'transfo' && <ChallengePage embedded />}
      {activeTab === 'defis' && <ChallengesPage embedded />}
      {activeTab === 'plans' && <BonPlanPage embedded />}
      {activeTab === 'commu' && <CommunautePage embedded />}
      {activeTab === 'comm' && isAdmin && <CommunicationTab />}

      <BottomNav />
    </div>
  );
}
